module.exports = __webpack_public_path__ + "img/KSAT25-45-1500-1-btn.ede054f7.png";